export const useFormChangeHandler = (setFormData) => {
  const handleChange = (e) => {
    console.log("Form data:", e);
    const { name, value, type, checked } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  return handleChange;
};

export const useFormChangeHandlerV2 = (setFormData) => {
  const handleChange = (e, name) => {
    if (e?.target) {
      // Jika berasal dari HTML standar
      const { name: inputName, value } = e.target;
      setFormData((prev) => ({
        ...prev,
        [inputName]: value,
      }));
    } else if (e?.value) {
      // Jika berasal dari react-select
      setFormData((prev) => ({
        ...prev,
        [name]: e.value, // Set nilai berdasarkan nama field
      }));
    }
  };
  return handleChange;
};
